import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Create root
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render App
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/*
  ===============================
  ✅ SERVICE WORKER REGISTRATION
  ===============================
*/
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("✅ Service Worker registered successfully:", registration);

        // Optional: listen for updates
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;

          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  console.log("🔄 New update available. Refresh to update.");
                } else {
                  console.log("📦 Content cached for offline use.");
                }
              }
            };
          }
        };
      })
      .catch((error) => {
        console.error("❌ Service Worker registration failed:", error);
      });
  });
}

/*
  ===============================
  📊 PERFORMANCE (OPTIONAL)
  ===============================
*/
reportWebVitals();